<div class="work-preferences-card">
  <div class="card-header">
    <h3 class="card-title">{{ 'work_preferences.title' | translate }}</h3>
    <span class="info-icon" (mouseenter)="showInfoTooltip = true" (mouseleave)="showInfoTooltip = false">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M12 16v-4" />
        <path d="M12 8h.01" />
      </svg>
      <div class="info-tooltip" *ngIf="showInfoTooltip">
        {{ 'work_preferences.tooltip_info' | translate }}
      </div>
    </span>
  </div>

  <form [formGroup]="form" class="preferences-form">
    <div class="form-field">
      <label class="field-label">
        {{ 'work_preferences.city_label' | translate }}
      </label>
      <bwc-city-input
        [control]="cityControl"
        [placeholder]="'work_preferences.city_placeholder' | translate"
      ></bwc-city-input>
    </div>

    <div class="form-field">
      <label class="field-label">
        {{ 'work_preferences.max_distance_label' | translate }}
      </label>
      <div class="distance-slider">
        <input
          type="range"
          [min]="0"
          [max]="distanceSteps.length - 1"
          [step]="1"
          [value]="distanceSliderValue"
          class="distance-range"
          (input)="onDistanceSliderChange($any($event.target).value)"
        />
        <span class="distance-label">{{ distanceLabel }}</span>
      </div>
    </div>

    <div class="form-field">
      <label class="field-label">
        {{ 'work_preferences.salary_label' | translate }}
      </label>
      <div class="salary-row">
        <input
          type="number"
          class="field-input salary-input"
          formControlName="salary"
          placeholder="€ 3000"
          step="1"
          min="0"
          inputmode="numeric"
          (input)="onSalaryInput($event)"
          (blur)="onSalaryChanged()"
        />
        <span class="salary-period-prefix">{{ 'work_preferences.per' | translate }}</span>
        <input
          type="text"
          class="field-input salary-period-input"
          [value]="'work_preferences.month' | translate"
          disabled
        />
      </div>
    </div>

    <div class="form-field">
      <label class="field-label">
        {{ 'work_preferences.hours_label' | translate }}
      </label>
      <lib-single-select-search
        class="preference-search"
        [options]="workHoursOptions"
        [control]="workHoursControl"
        [placeholder]="'work_preferences.select_placeholder' | translate"
        [myFloatLabel]="'never'"
        [forceControl]="true"
        [setControlValue]="true"
        [forceControlByOptions]="true"
        [disabledTyping]="true"
        [disableSearchOptionFiltering]="true"
        [waitForOptionsChange]="true"
        (changed)="onWorkHoursSelected($event)"
      ></lib-single-select-search>
    </div>

    <div class="form-field">
      <label class="field-label">
        {{ 'work_preferences.education_level_label' | translate }}
      </label>
      <lib-single-select-search
        class="preference-search"
        [options]="educationLevelOptions"
        [control]="educationLevelControl"
        [placeholder]="'work_preferences.select_placeholder' | translate"
        [myFloatLabel]="'never'"
        [forceControl]="true"
        [setControlValue]="true"
        [forceControlByOptions]="true"
        [disabledTyping]="true"
        [disableSearchOptionFiltering]="true"
        [waitForOptionsChange]="true"
        (changed)="onEducationLevelSelected($event)"
      ></lib-single-select-search>
    </div>

    <div class="form-field">
      <label class="field-label">
        {{ 'work_preferences.desired_occupations_label' | translate }}
      </label>
      <lib-single-select-search
        class="preference-search"
        [options]="professionOptions"
        [control]="occupationSearchControl"
        [placeholder]="'work_preferences.search_occupation_placeholder' | translate"
        [myFloatLabel]="'never'"
        [addDebounce]="300"
        [waitForOptionsChange]="true"
        [clearInput]="true"
        (changed)="onProfessionSelected($event)"
        (valueChanged)="onProfessionSearchChanged($event)"
      ></lib-single-select-search>
      <div class="occupation-chips" *ngIf="dreamProfessions.length > 0">
        <div class="occupation-chip" *ngFor="let profession of dreamProfessions; let i = index">
          <span class="chip-text">{{ profession.name }}</span>
          <button
            type="button"
            class="chip-remove"
            (click)="removeOccupation(i)"
            [attr.aria-label]="('work_preferences.remove_occupation' | translate) + ' ' + profession.name"
          >
            &times;
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
